/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Navigation/Navigation.ts" />
namespace HA.Core.Controller.Navigation {
    import NavigationTag = HA.Core.HTML.Navigation.Navigation;
    import Anchor = HA.Core.HTML.Anchor;
    import Tag = HA.Core.HTML.Tag;

    export class Navigation extends Controller {
        /**
         *
         * @param data
         * @returns {any}
         */
        protected static createItemController(data: Map<any, any>) {
            if (data.has("controllerName")) {
                return createService(HA.Core.Controller.Navigation, data.get("controllerName"), data);
            }

            return new NavigationItem(data);
        }

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.addToData("tag", new NavigationTag(toMap(data)));
            this.initAnchors();
            if(this.has("skip")) {
                return;
            }
            this.initializeItems();
        }

        private initAnchors(tag?: Tag): void {
            tag = tag || this.getTag();
            const anchors = tag.fetchByTagName("a");
            anchors.forEach((anchor: Tag) => {
                if (anchor.getAttribute("i")) {
                    return;
                }
                anchor.setAttribute("i", "1");
                const data = new Map();
                data.set("tag", anchor);
                data.set("services", getService4App());
                new Anchor(data);

            });
        }

        protected initializeItems() {
            this.addToData("itemControllers", new Map());
            const items = this.getItems();
            if (items) {
                const me = this;
                items.forEach((item: any) => {
                    me.addItem(toMap(item));
                });
            }
        }

        /**
         *
         * @param data
         */
        protected addItem(data: Map<any, any>) {
            const config = toMap(data);
            config.set("services", this.getItemService());
            config.set("pelement", this.getTag());
            this.getItemControllers().set(data.get("id"), Navigation.createItemController(config));
        }

        protected getItemService() {
            return this.get("services");
        }

        /**
         *
         * @returns {Map}
         */
        protected getItemControllers() {
            return this.get("itemControllers");
        }

        /**
         *
         * @returns {Map}
         */
        protected getItems() {
            return this.get("items");
        }
    }
}
